import { SanityModularLandingPageData, SanityModularLandingPageResponse } from 'types/sanity/modular-landing-page';
import { ModularLandingPageQuery } from './queries/modular-landing-page';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getModularLandingPage(slug: string): Promise<SanityModularLandingPageData | null> {
	const { data } = await useQuery<SanityModularLandingPageResponse>({
		client: villusClient,
		query: ModularLandingPageQuery,
		variables: { slug },
		tags: ['modular_landing_page']
	}).execute();

	return data?.allModularLandingPage?.[0] ?? null;
}
